<script>
	import vue2Dropzone from "vue2-dropzone"
	import "vue2-dropzone/dist/vue2Dropzone.min.css"
	import "vue-form-wizard/dist/vue-form-wizard.min.css"
	import Layout from "../../layouts/main"
	import PageHeader from "@/components/page-header"
	import appConfig from "@/app.config"
	import Multiselect from "vue-multiselect"
	import moment from 'moment'
	import DatePicker from "vue2-datepicker"
	import { required } from "vuelidate/lib/validators"

	import * as customValidators from '@/utils/validators'

	export default {
		components: {
			vueDropzone: vue2Dropzone,
			Layout,
			PageHeader,
			Multiselect,
			DatePicker,
		},
		page: {
			title: "Form File Upload",
			meta: [
				{
					name: "description",
					content: appConfig.description,
				},
			],
		},
		validations: {
			candidateName: {
				required,
				validateText: customValidators.validateText,
			},
			annualCtc: {
				required,
				validateNumber: customValidators.validateNumber,
			},
			designation: {
				required,
				validateText: customValidators.validateText,
			},
			phoneNumber: {
				required,
				validatePhone: customValidators.validatePhone,
			},
			joiningDate: {
				required,
				validateDate: customValidators.validateDate,
			},
		},
		data() {
			return {
				title: "Form File Upload",
				items: [
					{
						text: "Forms",
						href: "/",
					},
					{
						text: "Form File Upload",
						active: true,
					},
				],
				corporateId: null,
				branches: [],
				selectedBranch: null,
				branchId: null,
				loading: false,
				candidateName: "",
				annualCtc: "",
				designation: "",
				phoneNumber: "",
				joiningDate: "",
				isSuperAdmin: false,
				number: "",
				data: [],
				journey: null,
				journeyList: [],
				offerExpiry: "",
				dropzoneOptions: {
					url: process.env.VUE_APP_BASE_URL + "onboarding/upload-offer-letter", //@TODO change this URL to prod url
					thumbnailWidth: 150,
					maxFilesize: 5,
					maxFiles: 1,
					addRemoveLinks: true,
					acceptedFiles: "application/pdf",
					headers: {
						'Authorization': "Bearer " + this.$cookies.get('authToken'),
					},
					paramName: function () {
						return "offerLetter";
					},
					/*success: function(file, response) {
						console.log(response)
						//file.previewElement.parentNode.removeChild(file.previewElement)
					}*/
				},
			};
		},
		computed: {
			// journeyErrorMessage: function() {
			// 	console.log(this.$v.journey.validateText)
			// 	if (!this.$v.journey.$dirty) return ''
			// 	if (!this.$v.journey.required) return "Select Journey name for Candidate"
			// 	if (!this.$v.journey.journeyValidator) return "Enter a valid journey name"
			// 	return ''
			// },
		},
		watch: {
			// journey: function(newVal) {
			// 	if (newVal) {
			// 		this.$v.journey.$touch()
			// 	}
			// },
		},
		mounted() {
			this.corporateId = sessionStorage.getItem('corporateId')
			if (this.corporateId !== undefined && this.corporateId !== null) {
				this.isSuperAdmin = true
			}
			this.getCorporateBranchList()
		},
		methods: {
			onPdfUpload(file, response) {
				this.data = response.data.onboardEmployeeDetail
				this.data.joiningDate = moment(this.data.joiningDate).format("DD-M-yyyy")
				this.candidateName = this.data.name
				this.annualCtc = this.data.annualCtc
				this.designation = this.data.designation
				this.phoneNumber = this.data.phoneNumber
				this.joiningDate = this.data.joiningDate
			},
			getCorporateBranchList: function() {
				this.isReportTableBusy = true,
				this.$api.post('corporate/get-branch', {
					corporateId: (this.corporateId !== undefined && this.corporateId !== null) ? this.corporateId : this.$storageData.corporateId,
				}).then((result) => {
					this.branches = result.data.data
					this.selectedBranch = this.branches[0]
					this.branchId = this.branches[0]._id
					this.getJourneyList()
				}).catch((error) => {
					console.log(error)
					alert("You don't have permissions to view this pages")
				});
			},
			getJourneyList: function() {
				let corporateId = (this.corporateId !== undefined && this.corporateId !== null) ? this.corporateId : this.$storageData.corporateId
				let branchId = (this.selectedBranch !== undefined && this.selectedBranch !== null) ? this.selectedBranch._id : this.$storageData.branchId
				this.$api.post('onboarding-journey/get-journey-list', {
					adminId: this.$storageData.id,
					corporateId: corporateId,
					branchId: branchId,
				}).then((result) => {
					this.journeyList = [];
					for (var i = 0;i < result.data.data.length;i++) {
						this.journeyList.push({
							journeyId: result.data.data[i].journeyId,
							journeyName: result.data.data[i].journeyName,
						})
					}
					this.journey = this.journeyList[0]
				}).catch((error) => {
					console.log(error)
				});
			},
			handleClick: function() {
				let corporateId = (this.corporateId !== undefined && this.corporateId !== null) ? this.corporateId : this.$storageData.corporateId
				let branchId = (this.selectedBranch !== undefined && this.selectedBranch !== null) ? this.selectedBranch._id : this.$storageData.branchId
				
				this.$v.$touch()
				
				if (!this.$v.$invalid) {
					this.$api.post('onboarding/update-onboard-employee-data', {
						onboardEmployeeId: this.data._id,
						onboardJourneyId: this.journey.journeyId,
						corporateId: corporateId,
						branchId: branchId,
						name: this.candidateName,
						phoneNumber: this.phoneNumber,
						annualCtc: this.annualCtc,
						joiningDate: this.joiningDate,
						designation: this.designation,
						offerExpiry:this.offerExpiry,
					}).then((result) => {
						let statusCode = result.data.responseCode
						if (statusCode === 200) {
							window.location.reload()
						}
						if (statusCode === 400) {
							this.$toast.error(result.data.response, {
								position: "top-right",
								timeout: 5000,
								closeOnClick: true,
								pauseOnFocusLoss: true,
								pauseOnHover: true,
								draggable: true,
								draggablePercent: 0.6,
								showCloseButtonOnHover: false,
								hideProgressBar: false,
								closeButton: "button",
								icon: true,
								rtl: false
							})
						}
					}).catch((error) => {
						console.log(error)
					})
				}
			}
		},
		middleware: "authentication",
	};
</script>
<style scoped>
	.vue-dropzone > .dz-preview .dz-remove {
		margin-right: 15px;
		color: #ea2828;
		z-index: 1000;
		border-color: #ea2828;
	}
	.helo.form-control {
		padding: 0;
		min-height: 0;
	}
</style>
<template>
	<Layout>
		<PageHeader :items="items" />
		<div class="row">
			<div class="col-12">
				<div class="card">
					<div class="card-body">
						<h4 class="card-title">Upload Offer letter</h4>
						<!-- file upload -->
						<vue-dropzone @vdropzone-success="(file, response) => onPdfUpload(file, response)"
							ref="myVueDropzone" id="dropzone" :options="dropzoneOptions">
							<div class="dropzone-custom-content">
								<i class="display-4 text-muted bx bxs-cloud-upload"></i>
								<h4>Drop files here or click to upload.</h4>
							</div>
							<!--<i class="mdi mdi-close" data-dz-remove></i>-->
							<img src="@/assets/images/remove.png" alt="" data-dz-remove />
						</vue-dropzone>
						<!-- Candidate details Form -->
						<div class="row">
							<div class="col-lg-6">
								<div class="form-group mb-4">
									<label class="col-md-3 col-form-label" for="userName">Candidate name</label>
									<div class="col-md-12">
										<input
											id="userName"
											type="text"
											class="form-control"
											name="userName"
											@input="$v.candidateName.$touch()"
											:class="{ 'is-invalid': $v.candidateName.$error }"
											v-model="candidateName" />
										<div v-if="$v.candidateName.$error" class="invalid-feedback">
											<div v-if="!$v.candidateName.required">Candidate name is required.</div>
											<div v-if="!$v.candidateName.validateText">Candidate name is invalid.</div>
										</div>
									</div>
								</div>
								<div class="form-group mb-4">
									<label class="col-md-3 col-form-label" for="ctc">Annual CTC</label>
									<div class="col-md-12">
										<input
											id="ctc"
											type="text"
											name="ctc"
											class="form-control"
											@input="$v.annualCtc.$touch()"
											:class="{ 'is-invalid': $v.annualCtc.$error }"
											v-model="annualCtc" />
										<div v-if="$v.annualCtc.$error" class="invalid-feedback">
											<div v-if="!$v.annualCtc.required">Enter Annual CTC</div>
											<div v-if="!$v.annualCtc.validateNumber">Enter valid amount</div>
										</div>
									</div>
								</div>
								<div class="form-group mb-4">
									<label class="col-md-3 col-form-label" for="designation">Designation</label>
									<div class="col-md-12">
										<input
											id="designation"
											type="text"
											name="ctc"
											class="form-control"
											@input="$v.designation.$touch()"
											:class="{ 'is-invalid': $v.designation.$error }"
											v-model="designation" />
										<div v-if="$v.designation.$error" class="invalid-feedback">
											<div v-if="!$v.designation.required">Enter a designation for Candidate</div>
											<div v-if="!$v.designation.validateText">Enter a valid designation for Candidate</div>
										</div>
									</div>
								</div>
							</div>
							<!-- end col -->
							<div class="col-lg-6">
								<div class="form-group mb-4">
									<label class="col-md-9 col-form-label" for="number">WA Number(for eg: 919876543210)</label>
									<div class="col-md-12">
										<input
											id="number"
											type="number"
											name="number"
											class="form-control"
											maxlength="10"
											@input="$v.phoneNumber.$touch()"
											:class="{ 'is-invalid': $v.phoneNumber.$error }"
											v-model="phoneNumber" />
										<div v-if="$v.phoneNumber.$error" class="invalid-feedback">
											<div v-if="!$v.phoneNumber.required">Enter candidate WhatsApp number</div>
											<div v-if="!$v.phoneNumber.validateNumber">Enter a valid candidate WhatsApp number</div>
										</div>
									</div>
								</div>
								<div class="form-group mb-4">
									<label class="col-md-9 col-form-label" for="date">Joining Date (Eg. 10-1-1900)</label>
									<div class="col-md-12">
										<input
											id="joiningDate"
											type="text"
											name="joiningDate"
											class="form-control"
											@input="$v.joiningDate.$touch()"
											:class="{ 'is-invalid': $v.joiningDate.$error }"
											v-model="joiningDate" />
										<div v-if="$v.joiningDate.$error" class="invalid-feedback">
											<div v-if="!$v.joiningDate.required">Enter joining date</div>
											<div v-if="!$v.joiningDate.validateDate">Enter a valid joining date</div>
										</div>
									</div>
								</div>
								<div class="form-group mb-4">
									<label class="col-md-3 col-form-label" for="expiry">Offer Expiry</label>
									<div class="col-md-12">
										<date-picker v-model="offerExpiry" format="DD MMM Y" append-to-body lang="en" />
									</div>
								</div>
							</div>
							<div class="col-lg-6">
								<div class="form-group mb-4">
									<label for="journeyName" class="col-md-3 col-form-label">Journey Name</label>
									<div class="col-md-12">
										<multiselect
											id="journeyName"
											class="helo form-control"
											v-model="journey"
											:options="journeyList"
											placeholder="Select Journey"
											track-by="journeyName"
											label="journeyName"
											:allow-empty="false"
											:multiple="false">
											<template slot="singleLabel" slot-scope="{ option }">{{ option.journeyName.trim() }}</template>
										</multiselect>
									</div>
								</div>
							</div>
							<div v-if="isSuperAdmin" class="col-lg-6">
								<div class="form-group mb-4">
									<label for="branch" class="col-md-3 col-form-label">Branch</label>
									<div class="col-md-12">
										<multiselect id="branch" class="helo" v-model="selectedBranch" :options="branches" placeholder="Select Branch" track-by="name" label="name" :allow-empty="false" :multiple="false">
											<template slot="singleLabel" slot-scope="{ option }">{{ option.name }}</template>
										</multiselect>
									</div>
								</div>
							</div>
						</div>
						<!-- end row -->
						<button type="submit" class="col-3 m-2 btn btn-themeYellow w-md waves-effect waves-light" :disabled="loading" @click="handleClick">Continue</button>
					</div>
					<!-- end card-body -->
				</div>
				<!-- end card -->
			</div>
			<!-- end col -->
		</div>
		<!-- end row -->
	</Layout>
</template>
